import SettingsContent from '../../../components/settings/settingscontent/SettingsContent.js';
import React from 'react'
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import NavTopBar from "../../../components/shared/device/NavTopBar.js";
import useSetLocation from "../../../helpers/hooks/useSetLocation.js";
import useInterval from "../../../helpers/hooks/useInterval.js";
import {loadCurrentDeviceWrapper} from "../../../helpers/deviceHelper.js";
import {IfDeviceFound} from "../../../components/dashboard/IfDeviceFound.js";
import {DevicePagesTopInformation} from "../technical/DevicePagesTopInformation.js";
import {useTranslation} from "react-i18next";
import {AnyReportedParameters, isAwareDevice} from "../../../helpers/helperfunctions.js";
import useNavigationGuardByRole from "../../../helpers/hooks/useNavigationGuardByRole.js";
import {allowedPageRoles} from "../../../helpers/constants.js";

/** Displays the settings page for an individual device */
export default function DeviceConfigurationsPage() {
    const { t } = useTranslation(['settingspage']);
    useSetLocation();
    useNavigationGuardByRole(allowedPageRoles.DeviceConfigurationsPage);
    const { deviceSerialNumber } = useParams();
    const { currentDevice } = useSelector(g => g.device);
    const dispatch = useDispatch();

    const awareMinFirmwareVersion = "1.4.7";
    const awareDevice = isAwareDevice(currentDevice.serial_number);

    function compareVersions(v1, v2) {
        const a = v1.split('.').map(Number);
        const b = v2.split('.').map(Number);
        for (let i = 0; i < 3; i++) {
            if ((a[i] || 0) > (b[i] || 0)) return true;
            if ((a[i] || 0) < (b[i] || 0)) return false;
        }
        return true; // equal is also "ok"
    }

    const reportedVersion = String(currentDevice?.device_twin?.reported?.applicationVersion || "0.0.0");
    const onlyShowReboot = awareDevice && !((reportedVersion.startsWith("0.") || compareVersions(reportedVersion, awareMinFirmwareVersion)));
        
    useInterval(() => {
        loadCurrentDeviceWrapper(currentDevice, deviceSerialNumber, dispatch);
    }, 5000);

    let content = null;

    if (!currentDevice.connected || !AnyReportedParameters(currentDevice)) {
        content = (
            <div className='d-flex flex-grow-1 bg-white rounded-3 p-3 mb-3'>
                <div>
                    {!currentDevice.connected
                        ? t('settingspage:settings_not_available_device_offline')
                        : t('settingspage:settings_not_available_no_parameters')}
                </div>
            </div>
        );
    } else if (AnyReportedParameters(currentDevice)) {
        content = <SettingsContent device={currentDevice} onlyShowReboot={onlyShowReboot} />;
    }

    return (
        <IfDeviceFound>
            <div className='d-flex flex-column flex-grow-1'>
                <DevicePagesTopInformation device={currentDevice} />
                <NavTopBar deviceSerialNumber={deviceSerialNumber} currentPage='configurations' />
                {content}
            </div>
        </IfDeviceFound>
    );
}